export class CMSService {
    static CMS_CONTEXT_URL = '/idpcms/videos/prod/';
    static feedStr = '.cmsfeed.js';
    static getUrl(tier?: string) {
        let protocol = "";
        let host: string = "";
        if (tier) {
            protocol = "https:";
            switch (tier) {
                case Tier.LOCAL: { host = Domain.LOCAL; break; }
                case Tier.PRESTAGE: { host = Domain.PRESTAGE; break; }
                case Tier.FINALSTAGE: { host = Domain.FINALSTAGE; break; }
                case Tier.TST05: { host = Domain.TST; break; }
                case Tier.PROD: { host = Domain.PROD; break; }
                case Tier.ORIGIN: {
                    host = Domain.PROD;
                    break;
                    }
                default : {
                    host = Domain.PROD;
                    }
                }
            }
        return protocol + host + this.CMS_CONTEXT_URL;
    }
}

export enum Tier {
    LOCAL = 'LOCAL',
    PRESTAGE = 'PRESTAGE',
    FINALSTAGE = 'FINALSTAGE',
    TST05 = 'TST05',
    PROD = 'PROD',
    ORIGIN = 'ORIGIN',
}

export enum Domain {
    PROD = '//www.att.com',
    FINALSTAGE = '//finalstage.att.com',
    PRESTAGE= '//prestage.att.com',
    LOCAL = '//idse2.dev.att.com:10081',
    TST = '//e-tst3.stage.att.com',
}
